import {EntityStore, StoreConfig} from "@datorama/akita";
import {UserState} from "./models";

@StoreConfig({name: 'user', resettable: true})
export class UserStore extends EntityStore<UserState> {
}